module.exports = __webpack_public_path__ + "static/media/the_carbon_challenge_tablet.d974f904.jpg";